import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'

import { ReasonCategory, Status, Type } from '@brighterly/lib-core-types/booking/enums'

import { listDemoNoShowStatuses } from './request-statuses'

export const isBookingTypeDemo = (booking: Booking | null): boolean => (booking?.type !== Type.Paid)

export const isAnyCanceledBooking = (booking: Booking | null): boolean => {
  const list = [Status.Canceled, Status.CanceledBad]
  return booking ? list.includes(booking.status) : false
}

export const isBookingCanceledByCustomer = (booking: Booking | null): boolean => {
  const customerReason = (booking?.reason_category === ReasonCategory.Customer)
  return isAnyCanceledBooking(booking) && customerReason
}

export const isPlannedBooking = (booking: Booking): boolean => {
  const list = [Status.Planned]
  return list.includes(booking.status)
}

export const isConfirmedBooking = (booking: Booking): boolean => {
  const list = isBookingTypeDemo(booking)
    ? [Status.Confirmed, Status.Planned]
    : [Status.Confirmed]
  return list.includes(booking.status)
}

export const isCancelBadBooking = (booking: Booking): boolean => {
  const list = [Status.CanceledBad]
  return list.includes(booking.status)
}

export const isCompletedBooking = (booking: Booking | null): boolean => {
  const list = [Status.Completed]
  return booking ? list.includes(booking.status) : false
}

export const isCanceledBooking = (booking: Booking): boolean => {
  const list = [Status.Canceled]
  return list.includes(booking.status)
}

export const isRescheduledBooking = (booking: Booking): boolean => {
  const list = [Status.Rescheduled]
  return list.includes(booking.status)
}

export const isInProgressBooking = (booking: Booking): boolean => {
  const list = [Status.InProgress]
  return list.includes(booking.status)
}

export const isReservedBooking = (booking: Booking): boolean => {
  const list = [Status.ReservedPlanned, Status.ReservedConfirmed]
  return list.includes(booking.status)
}

export const isDemoNoShowBooking = (booking: Booking | null): boolean => {
  const demo = isBookingTypeDemo(booking)
  const status = booking?.status || null
  const noShow = status ? listDemoNoShowStatuses.includes(status) : false
  return demo && noShow
}

